<script lang="ts" setup>
import UserInboxBellButton from '@/components/inbox/UserInboxBellButton.vue'
import Footer from '@/layouts/components/Footer.vue'
import UserProfile from '@/layouts/components/UserProfile.vue'
import navItems from '@/navigation'
import { useThemeConfig } from '@core/composable/useThemeConfig'
import logo from '@images/logos/vector.svg'
import { VerticalNavLayout } from '@layouts'

const { appRouteTransition, isLessThanOverlayNavBreakpoint } = useThemeConfig()
const { width: windowWidth } = useWindowSize()
</script>

<template>
  <VerticalNavLayout :nav-items="navItems">
    <!-- 👉 Suppress the sidebar's own header logo — logo lives in the top navbar instead -->
    <template #vertical-nav-header />

    <!-- 👉 navbar -->
    <template #navbar="{ toggleVerticalOverlayNavActive }">
      <div class="d-flex h-100 align-center">
        <IconBtn
          v-if="isLessThanOverlayNavBreakpoint(windowWidth)"
          id="vertical-nav-toggle-btn"
          class="ms-n3"
          @click="toggleVerticalOverlayNavActive(true)"
        >
          <VIcon icon="mdi-menu" />
        </IconBtn>

        <RouterLink class="d-flex align-center gap-x-3" to="/">
          <VImg :src="logo" height="22" width="155" />
        </RouterLink>

        <VSpacer />

        <UserInboxBellButton class="me-2" />
        <UserProfile />
      </div>
    </template>

    <!-- 👉 Pages -->
    <RouterView v-slot="{ Component, route }">
      <!-- Match the provider/former-horizontal transition: no mode="out-in".
           out-in waits for leave to finish before enter, and can leave the
           content area blank until a hard refresh if the leave transition
           never completes. Key by route so different pages always remount. -->
      <Transition :name="appRouteTransition || ''" appear>
        <Component :is="Component" :key="route.path" />
      </Transition>
    </RouterView>

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>
  </VerticalNavLayout>
</template>
